//custom.js
$(document).ready(function () {
    if ($(".cart-edit_popup-title").text().trim() === "Complete the Look") {
        $(".cart-edit_form-submit").text("Add To Cart");
    }

    $(document).on("click", ".filter-icon", function () {
        $(".facets-vertical").toggleClass("open-drawer");
    });

    var pre_color = "#fff";

    $("body").on("input", '[name="properties[Notes]"]:not(.name-input)', function () {
        var notes = $(this).val();

        // Check if this is a preselected product
        if ($(this).hasClass("preselected-textarea") || $(this).closest(".preselected-product").length > 0) {
            // For preselected products, only update preview text
            var previewTextBoxs = $(this).closest(".customDescription").find(".preview_texts .preview_texts_inner");
            previewTextBoxs.each(function () {
                var value = notes.replace(/(?!<br>)([^\s\n\r])/g, '<span class="">$1</span>');
                $(this).html(value.replace(/\n/g, "<br>") || "");
                // ADD THIS LINE: Apply fitText to preselected products too
                fitText($(this), true);
            });
            return; // Exit early, don't run color selection logic
        }

        // FIXED: Regular product logic - use .customDescription instead of .per-parent-prod
        var previewTextBoxs = $(this).closest(".customDescription").find(".preview_texts .preview_texts_inner");

        previewTextBoxs.each(function () {
            var value = notes.replace(/(?!<br>)([^\s\n\r])/g, '<span class="">$1</span>');
            $(this).html(value.replace(/\n/g, "<br>") || "");
            fitText($(this));
        });

        $(this).closest("line-item-properties").find('[name="color_selected"][value="Each character Same Color"]').attr("checked", true).trigger("click");
        const $input = $(this).closest("line-item-properties").find("#samecolor");
        set_color($input);
    });

    // FIXED: Add check in set_color function too
    function set_color(input = $("[name=color_selected]")) {
        // Exit if this is a preselected product
        if (input.closest(".preselected-product").length > 0) {
            return;
        }

        var colorPersonalization = input.closest("color-personalization");
        var notes = input.closest("line-item-properties").find('[name="properties[Notes]"]').val();
        var list = colorPersonalization.find(".color-select__list");
        var isSameColor = (input ? input.val() === "Each character Same Color" : false) || !notes.length;

        // Rest of your existing set_color function...
        // (keeping the existing logic for regular products)
    }

    if ($('input[name="Add Personalization?"]:checked').length > 0) {
        if ($('input[name="Add Personalization?"]:checked').val().toUpperCase() == "YES") {
            $(".parent_div").show();
        } else {
            $(".parent_div").hide();
        }
    }

    $("body").on("keyup", ".optional_generic_note", function () {
        $(this.form).closest("product-info").find(".empty_error").remove();
    });
    // Show or hide the textarea based on radio button selection
    $("body").on("change", 'input[name="Add Personalization?"]', function () {
        console.log($(this).val());
        $(this).closest("product-info").find(".empty_error").remove();
        if ($(this).val().toUpperCase() === "YES") {
            console.log($(this).closest("product-info").find(".parent_div"));
            $(this).closest("product-info").find(".parent_div").slideDown(); // Show the textarea
        } else {
            $(this).closest("product-info").find(".parent_div").slideUp(); // Hide the textarea
        }
    });

    $("body").on("click", ".font-select [type=radio]", function () {
        var $input = $(this);
        var fontFamily = $input.data("font-family");
        var fontSizeAndHeight = getFontSizeForFontFamily(fontFamily).split("/");
        var previewTextBoxs = $input.closest(".perparent-prod").find(".preview_texts .preview_texts_inner");
        console.log(fontSizeAndHeight, " fontSizeAndHeight");
        previewTextBoxs.each(function () {
            $(this).css({
                "font-family": fontFamily,
                "font-size": fontSizeAndHeight[0],
                "line-height": fontSizeAndHeight[1],
                "letter-spacing": fontSizeAndHeight[2],
            });
            fitText($(this));
        });
        if ($('[name="color_selected"]').length > 0) {
            $('[name="color_selected"]:checked').click();
        }
    });

    $("body").on("click", ".color-select__select", function () {
        const $selectLabel = $(this);
        $(".color-select__select").not($selectLabel).removeClass("active");
        $selectLabel.toggleClass("active");
    });

    $("body").on("click", ".color-select__option", function () {
        const $option = $(this);
        const $select = $option.closest(".color-select");

        $select.find(".color-select__option").removeClass("selected");
        $option.addClass("selected");

        const colorCode = $option.data("code");
        const previewTextBoxs = $option.closest(".perparent-prod").find(".preview_texts");

        previewTextBoxs.each(function () {
            $(this).css("color", colorCode);
        });

        updateColorSelects($option.closest(".line-item-properties"));
    });

    if ($("#ColorShadesData").length > 0) {
        var colorsData = JSON.parse(document.getElementById("ColorShadesData").textContent) || [];
        if ($("#pro_ColorShadesData").length > 0) {
            colorsData = JSON.parse(document.getElementById("pro_ColorShadesData").textContent);
            colorsData = colorsData.items;
        }
        console.log(colorsData);
        var html = "";
        for (var [index, color] of colorsData.entries()) {
            html += `
        <input type="radio" id="color-shade-${index}" name="color-shades" value="${color.name}" data-hex="${color.code}" class="visually-hidden color-select__input"}>
        <label for="color-shade-${index}" class="color-select__input-label">
          <img src="${color.src}" alt="${color.name}">
        </label>`;
        }
        $("color-select").html(html).addClass("show");
    }

    $("body").on("change, click", ".color-select__input", function () {
        var $colorPersonalization = $(this).closest("color-personalization");
        var $items = $colorPersonalization.find(".color-select__item");

        var activeItem = $colorPersonalization.find(".active").length > 0 ? $($colorPersonalization.find(".active")[0]).find("input") : $items.find("input")[0];

        console.log(activeItem, $items.find("input")[0]);
        $(activeItem).removeClass("active");
        console.log("k jhkj kjn ", $(this).attr("data-hex"));
        $(activeItem).val($(this).val(), " $activeItem", activeItem);
        $(activeItem).attr("data-hex", $(this).attr("data-hex"));
        $(activeItem).closest(".color-select__item").addClass("active-done");

        $(this).closest(".color-select").removeClass("show");
        pre_color = $(this).attr("data-hex");
        setCharactersColor($(this).closest(".perparent-prod").find(".preview_texts"), $(this).closest("product-info").find("color-personalization"));
        $(this).closest("line-item-properties").find(".change_color_name").html($(this).attr("value"));

        if ($(this).closest("product-info").find(".color_selected_error").length > 0) {
            $(this).closest("product-info").find(".color_selected_error").remove();
        }

        if ($(this).hasClass("color_error")) {
            $(this).removeClass("color_error");
        }
    });

    function set_color(input = $("[name=color_selected]")) {
        if (input.parents(".preselected-product").length > 0 || input.length == 0) {
            return;
        }

        var colorPersonalization = input.closest("color-personalization");

        var notes = input.closest("line-item-properties").find('[name="properties[Notes]"]').val();
        var list = colorPersonalization.find(".color-select__list");
        var isSameColor = (input ? input.val() === "Each character Same Color" : false) || !notes.length;
        console.log(isSameColor, " isSameColor");
        var form_id = input.closest("product-info").find('[data-type="add-to-cart-form"]').attr("id");
        list.empty();

        if (isSameColor) {
            var selectedColor = colorPersonalization.find(".color-select__input:checked");
            var colorValue = selectedColor.length ? selectedColor.val() : getDefaultColor().name;
            var colorCode = selectedColor.length ? selectedColor.data("hex") : getDefaultColor().code;

            if (
                (input.closest("product-info").find(".thisis_color_radio:checked").attr("value").toUpperCase().indexOf("CREAM") >= 0 ||
                    input.closest("product-info").find(".thisis_color_radio:checked").attr("value").toUpperCase().indexOf("WHITE") > 0) &&
                selectedColor.length == 0
            ) {
                colorValue = "MULTICOLOR";
                colorCode = "#000";
            } else {
                colorValue = selectedColor.length ? selectedColor.val() : getDefaultColor().name;
                colorCode = selectedColor.length ? selectedColor.data("hex") : getDefaultColor().code;
            }

            colorPersonalization.find(".color-select").addClass("is-same-color");

            console.log(allSelectedColors, " in functi0on");
            colorValue = allSelectedColors.length > 0 ? allSelectedColors[0].value : colorValue;
            colorCode = allSelectedColors.length > 0 ? allSelectedColors[0].hex : colorCode;
            var active_done = allSelectedColors.length > 0 ? (allSelectedColors[0].active && colorValue != " " ? "active-done" : " ") : " ";
            list.addClass("hidden").html(`
        <label class="color-select__item ${active_done}">
          <input type="hidden" name="properties[Color]" value="${colorValue}" data-hex="${colorCode}" form="${form_id}">
          <span>All</span>
        </label>
      `);
            setTimeout(function () {
                if (active_done == "active-done") {
                    console.log(list.closest("product-info").find(".change_color_name"), colorValue);
                    list.closest("product-info").find(".change_color_name").html(colorValue);
                } else {
                    list.closest("product-info").find(".change_color_name").html(" ");
                }
            }, 800);

            list.closest("product-info")
                .find(".preview_texts_inner")
                .each(function (ii, vv) {
                    $(vv)
                        .find("span")
                        .each(function (i1, v1) {
                            console.log(colorValue, " khkjhj ");
                            $(v1).removeClass("striped-text");
                            if (colorValue.toUpperCase().indexOf("MULTICOLOR") >= 0) {
                                $(v1).css("color", "transparent");
                                $(v1).css("--color_stroke", colorCode);

                                $(v1).css("-webkit-text-stroke", "1px " + colorCode);
                                $(v1).css("text-stroke", "1px " + colorCode);
                            } else {
                                $(v1).css("--color_stroke", "transparent");
                                $(v1).css("color", colorCode);

                                $(v1).css("-webkit-text-stroke", "1px transparent");
                                $(v1).css("text-stroke", "1px transparent");
                            }
                        });
                });

            input.closest("line-item-properties").find('[name="color-shades"]:checked').trigger("change");
        } else {
            var text = notes;
            var colorIndex = 0;

            // list.closest('product-info').find('.preview_texts_inner').find('span').addClass('striped-text');

            for (let i = 0; i < text.length; i++) {
                var char = text.charAt(i);

                if (char !== "\n" && char !== " ") {
                    var colorData = getCharacterColorData(colorIndex++);
                    console.log(colorData);
                    var active = "";

                    var colorData_name = colorData.name;
                    var colorData_code = colorData.code;
                    var active_done = "";

                    colorData_name = allSelectedColors_diff.length > 0 ? (allSelectedColors_diff[i] != undefined ? allSelectedColors_diff[i].value : colorData_name) : colorData_name;
                    colorData_code = allSelectedColors_diff.length > 0 ? (allSelectedColors_diff[i] != undefined ? (allSelectedColors_diff[i].value != " " ? allSelectedColors_diff[i].hex : "#fff") : colorData_code) : colorData_code;
                    active_done = allSelectedColors_diff.length > 0 ? (allSelectedColors_diff[i] != undefined ? (allSelectedColors_diff[i].active && colorData_code != " " ? "active-done" : " ") : " ") : " ";

                    if (i == 0) {
                        active = "active";
                        // setTimeout(function(){
                        if (active_done == "active-done") {
                            list.closest("product-info").find(".change_color_name").html(colorData_name);
                        } else {
                            list.closest("product-info").find(".change_color_name").html(" ");
                        }
                        // },800);
                    }
                    list.removeClass("hidden").append(`
            <label class="color-select__item ${active} ${active_done}" data-character="${char}" data-index="${i}">
              <input type="hidden" name="properties[Color ${char}-${i}]" value="${colorData_name}" data-hex="${colorData_code}" form="${form_id}">
              <span>${char}</span>
            </label>
          `);
                    list.closest("product-info")
                        .find(".preview_texts")
                        .each(function (ii, vv) {
                            $(vv)
                                .find("span")
                                .each(function (i1, v1) {
                                    $(v1).removeClass("striped-text");
                                    if (i1 == i) {
                                        if (colorData_name.toUpperCase().indexOf("MULTICOLOR") >= 0) {
                                            $(v1).css("color", "transparent");
                                            $(v1).css("--color_stroke", colorData_code);

                                            $(v1).css("-webkit-text-stroke", "1px " + colorData_code);
                                            $(v1).css("text-stroke", "1px " + colorData_code);
                                        } else {
                                            $(v1).css("--color_stroke", "transparent");
                                            $(v1).css("color", colorData_code);

                                            $(v1).css("-webkit-text-stroke", "1px transparent");
                                            $(v1).css("text-stroke", "1px transparent");
                                        }
                                    }
                                });
                        });
                }
            }

            setItemsEventListeners(list);
        }

        // input.closest('line-item-properties').find('.change_color_name').html(input.closest('line-item-properties').find('[name="color-shades"]:checked').attr("value"));

        setCharactersColor(input.closest(".perparent-prod").find(".preview_texts"), $(this).closest("product-info").find("color-personalization"));
    }

    if ($("body.template-product").length > 0 && $("body").find(".show_personalize_data").length > 0 && document.querySelector(".preview_texts") != null) {
        // set_color();
        if ($("body").find(".thisis_color_radio").length > 0) {
            var label = document.querySelector("label[for=" + $("body").find(".thisis_color_radio:checked").attr("id") + "]");
            console.log("mnbvhj nbvn bv", label);
            if (label) {
                var bgColor = label.dataset.bg;
                var bgImage = label.dataset.bg_image;

                var targetDiv = document.querySelector(".preview_texts");
                // FIXED: Also apply to preselected preview texts
                var preselectedDiv = document.querySelector("#preselected-preview-texts");
                if (targetDiv && (bgColor != "" || bgImage != "")) {
                    console.log(targetDiv, bgColor, bgImage);
                    setTimeout(function () {
                        $(targetDiv).css("background-color", bgColor);
                        $(targetDiv).css("background-image", bgImage);
                        // FIXED: Apply same styling to preselected preview
                        if (preselectedDiv) {
                            $(preselectedDiv).css("background-color", bgColor);
                            $(preselectedDiv).css("background-image", bgImage);
                        }
                    }, 200);
                }
            }
        }
    }

    var allSelectedColors = [];
    var allSelectedColors_diff = [];

    $("body").on("change", "#samecolor, #differentcolor", function () {
        const $input = $(this);
        var all = [];
        console.log($input, " kjjhjhjhjhj", allSelectedColors);

        if ($(this).closest("product-info").find('[name="color_selected"]:checked').val() == "Each character Same Color") {
            $(this).closest("product-info").find(".change_step_text_color").html("Step 4: Choose Color for the name");
        } else {
            $(this).closest("product-info").find(".change_step_text_color").html("Step 4: Click on each letter and choose its color!");
        }

        $(this)
            .closest("product-info")
            .find(".color-select__list input")
            .each(function () {
                if ($(this).parents(".active-done").length > 0) {
                    all.push({
                        hex: $(this).data("hex"),
                        value: $(this).val(),
                        active: true,
                    });
                } else {
                    all.push({
                        hex: $(this).data("hex"),
                        value: " ",
                        active: false,
                    });
                }
            });

        if ($(this).attr("id") == "samecolor") {
            allSelectedColors_diff = all;
        } else {
            allSelectedColors = all;
        }

        set_color($(this));
    });

    function fitText($element, preselected = false) {
        const element = $element.get(0);
        const parentElement = element.parentElement;
        if (!parentElement) return;

        var containerWidth = parentElement.offsetWidth;
        const containerHeight = parentElement.offsetHeight;

        const style = window.getComputedStyle(parentElement);

        containerWidth = containerWidth - parseFloat(style.paddingLeft) - parseFloat(style.paddingRight);

        const fontFamily = window.getComputedStyle(element).fontFamily;
        var fontSizeDetails = getFontSizeForFontFamily(fontFamily.replaceAll('"', "")).split("/");
        if (preselected == true) {
            fontSizeDetails = getPreselected_font(fontFamily.replaceAll('"', "")).split("/");
        }

        var fontSize = parseFloat(fontSizeDetails[0]);
        console.log(fontSize, fontFamily.replaceAll('"', ""));
        const lineHeight = parseFloat(fontSizeDetails[1]) || 1.2;
        const letterSpacing = fontSizeDetails[2] || "0px";

        element.style.fontSize = `${fontSize}px`;
        element.style.lineHeight = lineHeight;
        element.style.letterSpacing = letterSpacing;
        element.style.whiteSpace = "nowrap";
        element.style.marginLeft = "0px";

        let textWidth = element.scrollWidth;
        let textHeight = element.scrollHeight;

        console.log(textWidth, textHeight, containerWidth, parentElement);

        // Removed requestAnimationFrame wrapper - direct execution
        while (textWidth > containerWidth && fontSize > 1) {
            fontSize--;
            element.style.fontSize = `${fontSize}px`;

            textWidth = element.scrollWidth;
            textHeight = element.scrollHeight;

            console.log(textWidth, textHeight, containerWidth);
        }
    }

    /* for preselected font */
    function getPreselected_font(fontFamily) {
        switch (fontFamily) {
            case "Bebas Neue":
                return "50px/1.1/0px";
                break;
            case "Calistoga Regular":
                return "40px/1.3/0px";
                break;
            case "Lunanew Regular":
                return "50px/2/0px";
            case "Luna":
                return "60px/1.2/0px";
                break;
            case "hailey joseph":
                return "65px/1.15/0px";
                break;
            case "abigail":
                return "80px/1.1/0px";
                break;
            case "Hello":
                return "58px/1.25/0px";
                break;
            case "Bestina Signature":
                return "62px/1.2/0px";
                break;
            case "Avocado Sans":
                return "55px/1.3/0px";
                break;
            case "Comic Neue":
                return "52px/1.35/0px";
                break;
            case "Times New Roman":
                return "48px/1.4/0px";
                break;
            default:
                return "60px/1.2/0px";
        }
    }

    /* for normal page */
    function getFontSizeForFontFamily(fontFamily) {
        switch (fontFamily) {
            case "Engebrechtre":
                return "40px/1.1/0px";
            case "Bebas Neue":
                return "50px/0.8/5px";
            case "New Era Casual":
                return "40px/1/0px";
            case "Hello":
                return "40px/1.35/0px";
            case "Caviar Dreams":
                return "40px/1/0px";
            case "abigail":
                return "40px/1.1/0px";
            case "Franklin Gothic Black":
                return "40px/1/0px";
            case "Cooper Blk BT":
                return "40px/1/0px";
            case "Gill Sans Nova":
                return "40px/1/0px";
            case "Abril Fatface":
                return "40px/1/0px";
            case "hailey joseph":
                return "40px/1.15/1px";
            case "Lunanew Regular":
                return "40px/2/0px";
            case "Calistoga Regular":
                return "40px/1.5/0.1px";
            case "Bestina Signature":
                return "40px/1/0px";
            case "Avocado Sans":
                return "40px/1.3/0px";
            case "Comic Neue":
                return "40px/1/0px";
            case "Times New Roman":
                return "40px/1/0px";
            case "Font P3":
                return "40px/2/10px";
            case "Font P2":
                return "40px/1.5/0.1px";
            case "Font P7":
                return "40px/1/0px";
            case "Font P8":
                return "40px/1.3/0px";
            case "Font P9":
                return "40px/1/0px";
            case "Font P10":
                return "40px/1.2/0px";
            case "Font P1":
                return "40px/0.8/5px";
            case "Font P6":
                return "40px/1.35/0px";
            case "Font P5":
                return "40px/1.1/0px";
            case "Font P4":
                return "40px/1.15/1px";
            default:
                return "30px/1.5/0px";
        }
    }

    function getfontfamily(fontFamily) {
        switch (fontFamily) {
            case "Font P1":
                return "Bebas Neue";
            case "Font P2":
                return "Calistoga Regular";
            case "Font P3":
                return "Lunanew Regular";
            case "Font P4":
                return "hailey joseph";
            case "Font P5":
                return "abigail";
            case "Font P6":
                return "Hello";
            case "Font P7":
                return "Bestina Signature";
            case "Font P8":
                return "Avocado Sans";
            case "Font P9":
                return "Comic Neue";
            case "Font P10":
                return "Times New Roman";
            default:
                return fontFamily;
        }
    }

    function updateColorSelects($container) {
        $container.find(".color-select").each(function () {
            const $select = $(this);
            const $option = $select.find(".color-select__option.selected").first() || $select.find(".color-select__option").first();

            $select.find(".color-select__color").css("background", $option.data("code"));
            $select.find(".color-select__text").text($option.data("value"));
            $select.find(".color-select__select").removeClass("active");
            $select.find(".color-select__input").val($option.data("value"));
        });
    }

    function getDefaultColor() {
        const colorsData = JSON.parse($("#ColorShadesData").text());
        return (
            colorsData[0] || {
                name: "Default",
                code: "#000000",
            }
        );
    }

    function getCharacterColorData(index) {
        const colorsData = JSON.parse($("#ColorShadesData").text());
        return colorsData.find((X) => X.code == $('[name="color-shades"]:checked').attr("data-hex") && X.name == $('[name="color-shades"]:checked').attr("value")) || getDefaultColor();
    }

    function setItemsEventListeners($list) {
        $list.find(".color-select__item").on("click", function () {
            const $item = $(this);
            const $input = $item.find("input");

            $list.find(".color-select__item").removeClass("active");
            $item.addClass("active");

            // $input.attr("data-hex",$input.data('hex'));
            $(this).closest("line-item-properties").find(".change_color_name").html($input.attr("value"));
            console.log(
                $(this)
                    .closest("line-item-properties")
                    .find('[name="color-shades"][data-hex="' + $input.attr("data-hex") + '"]'),
                $input.val(),
                $input.attr("data-hex")
            );
            $(this)
                .closest("line-item-properties")
                .find('[name="color-shades"][data-hex="' + $input.attr("data-hex") + '"]')
                .prop("checked", true)
                .attr("checked", true)
                .trigger("click");
            $item.closest(".color-select").removeClass("show");

            if ($(this).closest("product-info").find(".color_selected_error").length > 0) {
                $(this).closest("product-info").find(".color_selected_error").remove();
            }

            if ($(this).hasClass("color_error")) {
                $(this).removeClass("color_error");
            }
        });
    }

    function setCharactersColor(targetColorPersonalization, colorPersonalization = $("color-personalization")) {
        console.log(targetColorPersonalization);

        var items = colorPersonalization.find(".color-select__item input");
        var characters = targetColorPersonalization.find("span");

        if (characters.length === 0) {
            console.warn("No characters found in targetColorPersonalization.");
            return;
        }

        if (items.length === 0) {
            console.warn("No color items found in colorPersonalization.");
            return;
        }

        console.log(`Applying colors to ${characters.length} characters from ${items.length} inputs.`);

        characters.each((index, character) => {
            var $character = $(character);

            var colorInput = items[index % items.length];
            var colorHex = $(colorInput).attr("data-hex") || "#000000";

            console.log(`Character: ${$character.text()}, Color: ${colorHex}`);
            var color_name = $(colorInput).attr("value").toUpperCase();
            console.log(color_name);

            if ($character.closest("product-info").find('[name="color_selected"]:checked').attr("value") == "Each character Same Color") {
                $character.removeClass("striped-text");
            } else if ($(colorInput).closest("label").hasClass("active")) {
                $character.removeClass("striped-text");
            }

            if (color_name.indexOf("MULTICOLOR") >= 0) {
                $character.css("--color_stroke", colorHex);
                $character.css("color", "transparent");
                $character.css("-webkit-text-stroke", "1px " + colorHex);
                $character.css("text-stroke", "1px " + colorHex);
                console.log("lk hk kjh k", colorHex);
            } else {
                $character.css("--color_stroke", "transparent");
                $character.css("color", colorHex);

                $character.css("-webkit-text-stroke", "1px transparent");
                $character.css("text-stroke", "1px transparent");
            }
        });
    }

    $("body").on("click", ".select-cousion-view", function () {
        $(".select-cousion-popup").addClass("active");
        $(".cousion-popup-overlay").addClass("popup-active");
        $("body").css("overflow-y", "hidden");
    });

    $("body").on("click", ".popup-close", function () {
        $(".select-cousion-popup").removeClass("active");
        $(".cousion-popup-overlay").removeClass("popup-active");
        $("body").css("overflow-y", "scroll");
    });

    $("body").on("change", ".selected_box_color input", function (e) {
        e.preventDefault();
        console.log("lkh ijkhk hj jh j j ");
        if ($(this).val() == "Each character Same Color") {
            $(this).closest("line-item-properties").find("[name=color_selected]").val("Each character Same Color");
            console.log($(this).closest("line-item-properties").find("#samecolor"));
            $(this).closest("line-item-properties").find("#samecolor").attr("checked", true).trigger("change");
            const $input = $(this).closest("line-item-properties").find("#samecolor");
            console.log($input, " kjjhjhjhjhj");
            set_color($input);
            console.log(",mbnm bjh bjhnj ", $(this).val());
        } else {
            $(this).closest("line-item-properties").find("[name=color_selected]").val("Each Character Different Color");
            $(this).closest("line-item-properties").find("#differentcolor").attr("checked", true).trigger("change");
            const $input = $(this).closest("line-item-properties").find("#differentcolor");

            console.log($input, " kjjhjhjhjhj");
            set_color($input);
            console.log(",mbnm bjh bjhnj ", $(this).val());
        }

        const colorPersonalizationEle = $(this).closest(".perparent-prod").find("color-personalization");
        if (colorPersonalizationEle) colorPersonalizationEle.trigger("click");
    });

    $("body").on("change", '.cart-edit [name="color_selected"]', function (e) {
        e.preventDefault();

        if ($(this).val() == "Each character Same Color") {
            $(this).closest("product-info").find(".change_step_text_color").html("Step 4: Choose Color for the name");

            console.log($(this).closest("line-item-properties").find("#samecolor"));
            const $input = $(this).closest("line-item-properties").find("#samecolor");
            console.log($input, " kjjhjhjhjhj");
            set_color($input);
            console.log(",mbnm bjh bjhnj ", $(this).val());
        } else {
            $(this).closest("product-info").find(".change_step_text_color").html("Step 4: Click on each letter and choose its color!");
            const $input = $(this).closest("line-item-properties").find("#differentcolor");
            console.log($input, " kjjhjhjhjhj");
            set_color($input);
            console.log(",mbnm bjh bjhnj ", $(this).val());
        }

        const colorPersonalizationEle = $(this).closest(".perparent-prod").find("color-personalization");
        if (colorPersonalizationEle) colorPersonalizationEle.trigger("click");
    });

    // $("body").on("change","#MainContent .selected_box_color",function(e){
    //   e.preventDefault();

    //   if ($(this).val() == 'Each character Same Color') {
    //     $(this).closest('line-item-properties').find('[name=color]').val('Each character Same Color');
    //     console.log($(this).closest('line-item-properties').find("#samecolor"));
    //     $(this).closest('line-item-properties').find("#samecolor").attr('checked', true).trigger("change");
    //     console.log(",mbnm bjh bjhnj ", $(this).val());
    //   } else {
    //     $(this).closest('line-item-properties').find('[name=color]').val('Each Character Different Color');
    //     $(this).closest('line-item-properties').find("#differentcolor").attr("checked",true).trigger("change");
    //     console.log(",mbnm bjh bjhnj ", $(this).val());
    //   }

    //   const colorPersonalizationEle = $(this).closest('.perparent-prod').find('color-personalization');
    //   if (colorPersonalizationEle) colorPersonalizationEle.trigger('click');
    // });

    $("body").on("click", ".preselector", function () {
        const preselector = this;
        const near_parent = this.closest(".for_pre_selector") || this.closest(".cart-edit");
        const preselectorData = JSON.parse(preselector.querySelector('[type="application/json"]').textContent);
        const preselectors = near_parent.querySelectorAll(".preselector");
        const previewTextBoxs = near_parent.querySelectorAll(".preview_texts .preview_texts_inner");
        const notes = near_parent.querySelector('line-item-properties [name="properties[Notes]"]');
        const fontInputs = near_parent.querySelectorAll(".font-select [type=radio]");
        const colorTypes = near_parent.querySelectorAll('color-personalization [name="color_selected"]');
        const colorInputs = near_parent.querySelectorAll("color-select .color-select__input");

        const variantSelectors = near_parent.querySelector("variant-selects") || near_parent.querySelector("variant-radios");
        console.log(variantSelectors, " juhjghj gjh");
        if (variantSelectors) variantSelectors.setOptions(preselectorData.options);

        preselectors.forEach((preselector2) => {
            preselector2.classList.remove("selected");
        });
        preselector.classList.add("selected");

        if (this.closest(".cart-edit") != null) {
            notes.value = stored_name;
            $(notes).trigger("input");
        } else if (notes.value == "") notes.value = preselectorData.name;

        previewTextBoxs.forEach((previewText) => {
            var value = notes.value.replace(/(?!<br>)([^\s\n\r])/g, "<span>$1</span>");
            if (this.closest(".cart-edit") != null) {
                value = value;
            }
            previewText.innerHTML = value.replace(/\n/g, "<br>");
        });

        fontInputs.forEach((input) => {
            if (input.value == preselectorData.font) input.click();
        });

        colorTypes.forEach((colorType) => {
            if (preselectorData.colors.length > 1 && colorType.value == "Each Character Different Color") {
                colorType.click();
                near_parent.querySelector(".selected_box_color").value = "Each Character Different Color";
            } else if (colorType.value == "Each character Same Color") {
                colorType.click();
                near_parent.querySelector(".selected_box_color").value = "Each character Same Color";
            }
        });

        colorInputs.forEach((colorInput) => {
            if (colorInput.value == preselectorData.colors[0].value) colorInput.click();
        });

        // updateColorSelects(preselectorData.colors);
    });

    $("body").on("click", ".summary__title", function () {
        console.log("click");
        $(this).toggleClass("active");
        $(this).parents(".product__accordion").find(".accordion__content").slideToggle();
    });

    $(document).on("click", ".custom_sort_sctive", function () {
        $(this).toggleClass("custom_sort_sctive-active"); // Add or remove the 'active' class
        $(".custom_select_drop_down").toggleClass("active"); // Toggle dropdown visibility
    });

    $(document).on("click", ".sharing-icon", function () {
        $(".product-social-sharing").toggleClass("active"); // Add or remove the 'active' class
    });

    $(document).on("focus", ".quantity__input", function () {
        $(this).closest("quantity-input").addClass("focus-quantity");
    });

    $(document).on("blur", ".quantity__input", function () {
        $(this).closest("quantity-input").removeClass("focus-quantity");
    });

    $("body").on("click", ".gridoption-wrp .gridoption-list .colorswatch-grid", function () {
        var img = $(this).find(".backimg").attr("data-img-url");
        $(this).parents(".gridoption-wrp").find(".backimg").removeClass("selected");
        $(this).find(".backimg").addClass("selected");
        var index = $(this)
            .parents(".grid__item")
            .find('.carousel-cell[data-img-url="' + img + '"]')
            .attr("data-index");
        $(this)
            .parents(".grid__item")
            .find('.card__media .flickity-page-dots [aria-label="Page dot ' + index + '"]')
            .trigger("click");
        var variant_id = $(this).attr("data-variant-id");
        $(".button-add-to-cart_main form").find(".product-variant-id").val(variant_id);
    });

    // $('body').on('click', '.facets_questions', function (e) {
    //   e.preventDefault();
    //   if ($(this).next('.facets_answers').is(':visible')) {
    //     $(this).next('.facets_answers').slideUp(200);
    //     $(this).closest('.facets__disclosure-vertical').removeAttr('open');
    //   } else {
    //     $(this).next('.facets_answers').slideDown(200);
    //     console.log($(this).closest('details'));
    //     $(this).closest('.facets__disclosure-vertical').attr('open', 'open');
    //   }
    // });
    $(".facets_questions:eq(0)").closest(".facets__disclosure-vertical").addClass("active").attr("open", "open");
    $(".facets_questions:eq(0)").next(".facets_answers").slideDown(200);
    $("body").on("click", ".facets_questions", function (e) {
        e.preventDefault();
        var _this = $(this);
        if ($(this).next(".facets_answers").is(":visible")) {
            $(this).next(".facets_answers").slideUp(200);
            $(this).closest(".facets__disclosure-vertical").removeClass("active");
            setTimeout(function () {
                _this.closest(".facets__disclosure-vertical").removeAttr("open");
            }, 200);
        } else {
            _this.closest(".facets__disclosure-vertical").addClass("active").attr("open", "open");
            $(this).next(".facets_answers").slideDown(200);
        }
    });

    $("body").on("click", "menu-drawer:not(.customsetup-filmob) summary.mobile-facets__summary", function (e) {
        e.preventDefault();
        var _this = $(this);
        if ($(this).next(".mobile-facets__submenu").is(":visible")) {
            $(this).next(".mobile-facets__submenu").slideUp(300);
            $(this).closest("details.mobile-facets__details").removeClass("active");
            setTimeout(function () {
                _this.closest("details.mobile-facets__details").removeAttr("open");
            }, 200);
        } else {
            $(this).next(".mobile-facets__submenu").slideDown(300);
            _this.closest("details.mobile-facets__details").addClass("active").attr("open", "open");
        }
    });

    $(document).on("keydown", ".collection-card-wrapper", function () {
        if (event.key === "Enter") {
            var url = $(this).data("url");
            if (url) {
                window.location.href = url;
            }
        }
    });

    $(document).on("keydown", ".tab-detail-list", function () {
        if (event.key === "Enter") {
            var url = $(this).data("url");
            if (url) {
                window.location.href = url;
            }
        }
    });

    $(document).on("click", ".facets_questions", function () {
        $(".facets_questions").addClass("active-facets_questions");
    });

    $(document).on("click", ".facets-container .facets__summary", function () {
        $(".facets-label").addClass("active-facets-label");
    });

    // When a product card is focused
    $(document).on("focus", ".product-card-wrapper", function () {
        $(this).addClass("focus");
    });

    $(document).on("blur", ".product-card-wrapper", function () {
        // Optionally, you can remove the class when the product card loses focus
        $(this).removeClass("focus");
    });

    $("body").on("click", ".custom-sort-option", function (event) {
        event.preventDefault();
        var selectedValue = $(this).data("value");
        $(".custom-sort-option").removeClass("active");
        $(this).addClass("active");
        $(".custom_select_drop_down li").each(function () {
            if ($(this).data("value") === selectedValue) {
                $(this).trigger("click");
            }
        });
        $(this).closest(".mobile-facets").find(".mobile-facets__close").trigger("click");
    });

    // When a product card is focused
    $(document).on("focus", ".new-arrival-section .carousel-cell", function () {
        $(this).addClass("focus");
    });

    $(document).on("blur", ".new-arrival-section .carousel-cell", function () {
        // Optionally, you can remove the class when the product card loses focus
        $(this).removeClass("focus");
    });

    //  $(document).on('click', '.facets__label', function() {

    //   if ($('.facets_answers').is(':visible')) {
    //       $('.facets_answers').slideUp(300);
    //       $('.footer-updown-accordion-icon').removeClass('updown-accordion-icon-show');
    //   }
    //   if ($(this).next('.facets_answers').is(':visible')) {
    //       $(this).next('.facets_answers').slideUp(300);
    //       $(this).find('.footer-updown-accordion-icon').removeClass('updown-accordion-icon-show');
    //   } else {
    //       $(this).next('.facets_answers').slideDown(300);
    //       $(this).find('.footer-updown-accordion-icon').addClass('updown-accordion-icon-show');
    //   }
    // });s

    function addedin_wishlist() {
        var storedl = localStorage.getItem("AddedToWishlist");
        var getlist = storedl ? JSON.parse(storedl) : [];

        if (getlist.length > 0) {
            for (var i = 0; i < getlist.length; i++) {
                var phandle = getlist[i].split(":");
                var vlist = phandle[1].split(",");
                if ($(".product__info-wrapper").length) {
                    for (var j = 0; j < vlist.length; j++) {
                        if ($('.product__info-wrapper .wishlist-icon[product-handle="' + phandle[0] + '"][data-varint-id="' + vlist[j] + '"]').length > 0) {
                            $('.product__info-wrapper .wishlist-icon[product-handle="' + phandle[0] + '"][data-varint-id="' + vlist[j] + '"]').addClass("added-in-wishlist");
                        }
                    }
                }
                if ($('.card-wrapper .wishlist-icon[product-handle="' + phandle[0] + '"]').length > 0) {
                    $('.card-wrapper .wishlist-icon[product-handle="' + phandle[0] + '"]').addClass("added-in-wishlist");
                }
                if ($('.template-cart .item-wrapper .wishlist-icon[product-handle="' + phandle[0] + '"]').length > 0) {
                    $('.template-cart .item-wrapper .wishlist-icon[product-handle="' + phandle[0] + '"]').addClass("added-in-wishlist");
                }
            }
        }
    }
    addedin_wishlist();

    function count_wishlist(my_data) {
        console.log(my_data);
        if (my_data.length == 0) {
            $("header .wishlist-wrapper").removeClass("active");
            $(".wishlist-section .nohave-any-item").removeClass("hidden");
        } else {
            $("header .wishlist-wrapper").addClass("active");
            $(".wishlist-section .nohave-any-item").addClass("hidden");
        }
    }
    var stored__ = localStorage.getItem("AddedToWishlist");
    var getlist = stored__ ? JSON.parse(stored__) : [];
    count_wishlist(getlist);

    function wishlistpage() {
        if ($(".wishlistpage").length > 0) {
            var storedl = localStorage.getItem("AddedToWishlist");
            var getlist = storedl ? JSON.parse(storedl) : [];
            if (getlist.length > 0 && storedl != "[null]" && storedl != null) {
                $(".nohave_any_item").addClass("hidden");
                $("#product-grid.whishlist-grid").empty();
                // $('.nohave-any-item').hide(); // Hides the empty wishlist message
                for (var i = 0; i < getlist.length; i++) {
                    var phandle = getlist[i].split(":");
                    $.get("/products/" + phandle[0] + "?view=wishlist-ajax", function (response) {
                        // console.log(response);
                        $("#product-grid.whishlist-grid").append(response);
                        $("#product-grid.whishlist-grid .wishlist-icon").addClass("added-in-wishlist");
                        $("#product-grid.whishlist-grid .whishlist-grid-item .gridmedia-slider").flickity({
                            cellAlign: "left",
                            contain: true,
                            wrapAround: true,
                            dragThreshold: 25,
                            touchVerticalScroll: true,
                            prevNextButtons: false,
                            pageDots: true,
                        });
                        if ($(".wishlistpagebody quick-add-modal").length > 0) {
                            $(".wishlistpagebody").remove("quick-add-modal");
                        }
                    });
                }
            } else {
                // $('.nohave-any-item').show()
                $(".nohave_any_item").removeClass("hidden");
            }
        }
    }
    wishlistpage();

    $("body").on("click", ".wishlist-icon", function (e) {
        e.preventDefault();

        var loadingbar = document.querySelector(".loading-bar");
        var loadingbarinner = document.querySelector(".loading-bar-inner");
        loadingbar.classList.add("is-visible");
        loadingbarinner.style.transform = "scaleX(0.4)";

        var not_added = false;
        var productHandle = $(this).attr("product-handle");
        var productvariant = $(this).attr("data-varint-id");
        var storedl = localStorage.getItem("AddedToWishlist");
        var getlist = storedl ? JSON.parse(storedl) : [];

        if (($(this).hasClass("added-in-wishlist") && !$(this).hasClass(".thisis_product")) || $(".wishlistpage").length > 0) {
            var newlist = [];
            for (var i = 0; i < getlist.length; i++) {
                var whole_obj = getlist[i].split(":");
                if (whole_obj[0] != productHandle) {
                    newlist.push(getlist[i]);
                }
            }
            count_wishlist(newlist);
            localStorage.setItem("AddedToWishlist", JSON.stringify(newlist));

            if ($(".wishlistpage").length > 0) {
                if (newlist.length == 0 || (newlist == "[null]" && newlist == null)) {
                    $(".nohave_any_item").removeClass("hidden");
                }
                $(this).parents(".whishlist-grid-item").remove();
            } else {
                $(this).removeClass("added-in-wishlist");
            }
        } else {
            var all_handles = [];
            var all_vriants = [];
            var is_in = 0;
            for (var i = 0; i < getlist.length; i++) {
                var whole_p = getlist[i].split(":");
                var pih = whole_p[0];
                var variants = whole_p[1].split(",");
                if (variants.indexOf(productvariant) > -1) {
                    is_in = 1;
                }
                all_handles.push(pih);
                all_vriants.push(whole_p[1]);
            }

            if (all_handles.indexOf(productHandle) == -1 && is_in == 0) {
                //add
                var new_p_handle = productHandle + ":" + productvariant;
                getlist.push(new_p_handle);
                count_wishlist(getlist);
                localStorage.setItem("AddedToWishlist", JSON.stringify(getlist));
                $(this).addClass("added-in-wishlist");
                $(".wishlist-succes-popup").addClass("open");
                setTimeout(function () {
                    $(".wishlist-succes-popup").removeClass("open");
                }, 5000);
            } else if (all_handles.indexOf(productHandle) > -1 && is_in == 0) {
                var sq = all_handles.indexOf(productHandle);
                var current_vrs = all_vriants[sq] + "," + productvariant;
                var new_p_handle = productHandle + ":" + current_vrs;
                getlist[sq] = new_p_handle;
                count_wishlist(getlist);
                localStorage.setItem("AddedToWishlist", JSON.stringify(getlist));
                $(this).addClass("added-in-wishlist");
                $(".wishlist-succes-popup").addClass("open");
                setTimeout(function () {
                    $(".wishlist-succes-popup").removeClass("open");
                }, 5000);
            } else {
                //remove
                $(this).removeClass("added-in-wishlist");
                var newlist = [];
                for (var i = 0; i < getlist.length; i++) {
                    var whole_obj = getlist[i].split(":");
                    var only_h = whole_obj[0];
                    if (only_h == productHandle) {
                        var only_vs = whole_obj[1].split(",");
                        var countvar = [];
                        for (var j = 0; j < only_vs.length; j++) {
                            if (only_vs[j] != productvariant) {
                                countvar.push(only_vs[j]);
                            }
                        }
                        if (countvar.length > 0) {
                            var cl = productHandle + ":" + countvar;
                            newlist.push(cl);
                        }
                        console.log(countvar);
                    } else {
                        newlist.push(getlist[i]);
                    }
                }
                // if(newlist.length == 0){
                //   $('.nohave-any-item').hide();
                // }
                count_wishlist(newlist);
                localStorage.setItem("AddedToWishlist", JSON.stringify(newlist));
            }
        }
        loadingbarinner.style.transform = "scaleX(1)";
        setTimeout(function () {
            loadingbar.classList.remove("is-visible");
            loadingbarinner.style.transform = "scaleX(0)";
        }, 1000);
    });

    // $('.facets-label').on('keydown click', function(e) {

    //   // Check if the event is a click or Spacebar key press (key code 32)

    //   if (e.keyCode === 32 || e.which === 32) {
    //     e.preventDefault(); // Prevent default spacebar behavior

    //     var currentFacet = $(this).closest('.facets__disclosure-vertical'); // Get the current filter section

    //     // Close any other open facets, remove 'open' attribute and slide up content

    //     $('.facets__disclosure-vertical').not(currentFacet).removeClass('open').removeAttr('open').find('.facets__display-vertical').slideUp();

    //     // Toggle the current facet's open class and attribute
    //     currentFacet.toggleClass('open');

    //     if (currentFacet.hasClass('open')) {
    //       currentFacet.attr('open', 'open'); // Add the open attribute when open
    //     } else {
    //       currentFacet.removeAttr('open'); // Remove the open attribute when closed
    //     }

    //     // Toggle visibility of the filter content (slide down/up effect)
    //     currentFacet.find('.facets__display-vertical').slideToggle();
    //   }
    // });

    $(".display_custom_sort").on("keydown", function (event) {
        if (event.key === "Enter") {
            // Get the dropdown element

            $("#SortBy").val(value).trigger("change");

            $("#SortBy")
                .find('option[value="' + value + '"]')
                .prop("selected", "selected")
                .click();

            // Get the selected value
            var value = $(this).val();

            // Call the sorting function
            sortByCollection(value);

            // Optionally log the action
            console.log("Sorting by:", value);

            var dropdown = $(".custom_select_drop_down");

            // Check if the dropdown is visible
            if (dropdown.is(":visible")) {
                // If it's visible, hide it
                dropdown.removeClass("active").attr("aria-hidden", "true");
                $(this).attr("aria-expanded", "false");
            } else {
                // If it's not visible, show it
                dropdown.addClass("active").attr("aria-hidden", "false");
                $(this).attr("aria-expanded", "true");
            }
        }
    });

    // Function to implement sorting logic
    function sortByCollection(value) {
        // Example sorting logic; replace with your actual implementation
    }
    $("body").on("click", ".cart-edit .cart_color_click", function (e) {
        e.preventDefault();
        var color_name = $(this).find("input").val();
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(".cart-edit .color-select").removeClass("show");
        } else {
            $(".cart-edit .cart_color_click").removeClass("active");
            $(this).addClass("active");
            $(".cart-edit .color-select").addClass("show");
            $(".cart-edit .color-select__input").each(function (ii, vv) {
                if ($(vv).val() == color_name) {
                    $(vv).attr("checked", true).trigger("click");
                }
            });
        }
        $(this).closest("line-item-properties").find(".change_color_name").html(color_name);
    });

    var $cartcarousel, $cartcarouselthumb, stored_name, stored_color_type;

    $("body").on("click", ".edit-button", function (e) {
        e.preventDefault();
        if ($('[name="color_selected"]').length > 0) {
            stored_color_type = $('[name="color_selected"]:checked').val();
        }
        var line_item = $(this).closest(".item-wrapper");
        var line_name = $(this).attr("data-name");
        stored_name = line_name;
        var line_cousion = $(this).attr("data-cousion");
        var line_fontfamily = $(this).attr("data-line_fontfamily");
        var line_single_color = $(this).attr("data-single_line_color");
        var current_qty = line_item.find("quantity-input input").val();
        $(".cart-edit").show();
        $(".cart-edit").attr("data-line_no", $(this).attr("data-item_line"));
        $(".cart-edit").attr("data-current-qty", current_qty);

        // Change modal title and button text when editing existing cart item
        $(".cart-edit_popup-title").text("Edit Item");
        $(".cart-edit_form-submit").text("Save Changes");

        $(".cart-edit-popup-body").addClass("loading");
        if ($(".cart-edit_main .product__media-list.carousel-main").hasClass("flickity-enabled")) {
            $cartcarousel.flickity("destroy");
            $cartcarouselthumb.flickity("destroy");
            $(".cart-edit_main .thumbnail-list.carousel-nav").empty();
            $(".cart-edit_main .product__media-list.carousel-main").empty();
        }
        var full_colors = "";
        var colorsDatas = JSON.parse(document.getElementById("ColorShadesData").textContent) || [];
        $.each(colorsDatas, function (index, val) {
            full_colors += val.name + val.code + ",";
        });
        console.log(full_colors);
        var href = $(this).attr("data-url");
        $.get(href, function (data) {
            $(".cart-edit-popup-body").html(
                `<div class="cart-edit_popup product product--left product--thumbnail_slider product--mobile-show">${$(data).find(".productsection .product").html().replaceAll("template--", "template--cart--")}${
                    $(data).find(".select-cousion-popup_wrp").length > 0 ? $(data).find(".select-cousion-popup_wrp").html() : " "
                }</div>`
            );
            $(".cart-edit-popup-body").removeClass("loading");
            // Initialize preselected product functionality if it exists
            if (window.initPreselectedProduct && $(".cart-edit").find("#preselected-variants").length > 0) {
                setTimeout(function () {
                    window.initPreselectedProduct();
                }, 200);
            }
        }).done(function (e) {
            if ($(".cart-edit").find("#pro_ColorShadesData").length > 0) {
                full_colors = "";
                var colorsDatas = JSON.parse($(".cart-edit").find("#pro_ColorShadesData").html()) || [];
                colorsDatas = colorsDatas.items;
                $.each(colorsDatas, function (index, val) {
                    full_colors += val.name + val.code + ",";
                });
                console.log(full_colors, " =======");
            }

            $(".cart-edit line-item-properties").find(".this-is-personalize-option").addClass("edit_cart");
            $(".cart-edit-popup-body").removeClass("loading");
            $('.cart-edit [name="properties[Notes]"]').val(line_name);
            $(".cart-edit .multi-image-section img").attr("src", line_cousion);
            $('.cart-edit [name="properties[_Cousion]"]').val(line_cousion);
            $('.cart-edit [name="properties[Font family]"][value="' + line_fontfamily + '"]')
                .attr("checked", true)
                .trigger("click");
            // console.log('~~~~',line_single_color);
            $(".cart-edit .product__description.rte.quick-add-hidden").hide();
            var colors_array = [];
            for (var i = 0; i < line_name.length; i++) {
                colors_array.push(line_name.charAt(i));
            }
            console.log(colors_array, " colors_array");
            $(".cart-edit .preview_texts .preview_texts_inner").html("").css("font-family", getfontfamily(line_fontfamily));
            for (let x = 0; x < colors_array.length; x++) {
                $(".cart-edit .preview_texts .preview_texts_inner").append("<span>" + colors_array[x].replace("\n", "<br>") + "</span>");
            }
            var form_id = $('.cart-edit form[data-type="add-to-cart-form"]').attr("id");
            if (line_name != "" && $(".cart-edit .only_note").length > 0) {
                $(".cart-edit line-item-properties").show();
                $(".cart-edit .parent_div").show();
            }
            if ($(".cart-edit").find(".thisis_color_radio").length > 0) {
                var label = document.querySelector("label[for=" + $(".cart-edit").find(".thisis_color_radio:checked").attr("id") + "]");
                console.log("mnbvhj nbvn bv", label);
                if (label) {
                    var bgColor = label.dataset.bg;
                    var bgImage = label.dataset.bg_image;

                    var targetDiv = document.querySelector(".preview_texts");
                    console.log(targetDiv, bgColor, bgImage);
                    if (targetDiv && (bgColor != "" || bgImage != "")) {
                        setTimeout(function () {
                            $(targetDiv).css("background-color", bgColor);
                            $(targetDiv).css("background-image", bgImage);
                        }, 200);
                    }
                }
            }
            var previewTextBoxs = $(".cart-edit").find(".perparent-prod").find(".preview_texts .preview_texts_inner");
            previewTextBoxs.each(function (index, val) {
                fitText($(val));
            });

            if (line_single_color != "") {
                console.log("~~~~if", line_single_color);
                $('.cart-edit [name="color_selected"]#samecolor').attr("checked", true).trigger("click");
                setTimeout(function () {
                    $('.cart-edit [name="color-shades"][value="' + line_single_color + '"]')
                        .attr("checked", true)
                        .trigger("click");
                }, 1000);
                setTimeout(function () {
                    $(".cart-edit").find(".change_color_name").html(line_single_color);
                }, 1200);
                var html_block_text = "";
                var colorCode = "#fff";
                full_colors = full_colors.split(",");
                for (let i = 0; i < full_colors.length; i++) {
                    var both_colors = full_colors[i].split("#");
                    if (both_colors[0] == line_single_color) {
                        colorCode = "#" + both_colors[1];
                    }
                }

                html_block_text += `<label class="color-select__item">
          <input type="hidden" name="properties[Color]" value="${line_single_color}" data-hex="${colorCode}" form="${form_id}">
          <span>All</span>
        </label>
          `;

                $(".cart-edit .color-select__list").addClass("hidden");

                console.log(html_block_text);
                console.log("-----------------");

                $(".cart-edit .color-select__list").html(html_block_text);
                $(".cart-edit .preview_texts span").each(function (ii, vv) {
                    var color_name = line_single_color.toUpperCase();
                    if (color_name.indexOf("MULTICOLOR") >= 0) {
                        $(vv).css("color", "transparent");
                        $(vv).css("--color_stroke", colorCode);

                        $(vv).css("-webkit-text-stroke", "1px " + colorCode);
                        $(vv).css("text-stroke", "1px " + colorCode);
                    } else {
                        $(vv).css("--color_stroke", "transparent");
                        $(vv).css("color", colorCode);

                        $(vv).css("-webkit-text-stroke", "1px transparent");
                        $(vv).css("text-stroke", "1px transparent");
                    }
                });
                console.log(colors_array);
            } else {
                console.log("~~~~else", line_single_color);
                $('.cart-edit [name="color_selected"]#differentcolor').attr("checked", true).trigger("change");
                var text_colors = [];
                var hax_colors = [];
                var text_color_pre = [];
                full_colors = full_colors.split(",");
                for (let i = 0; i < full_colors.length; i++) {
                    var both_colors = full_colors[i].split("#");
                    text_colors.push(both_colors[0]);
                    hax_colors.push("#" + both_colors[1]);
                    text_color_pre.push(both_colors);
                }
                $(".cart-edit .color-select__list").removeClass("hidden");
                var html_block_text = "";
                var text_color = [],
                    text_color_name = [];
                for (let x = 0; x < colors_array.length; x++) {
                    var pname = "Color " + colors_array[x] + "-" + x;
                    var color_l = line_item.find('.product-option[data-key="' + pname + '"]').attr("data-val") || "white";
                    console.log(pname + " == " + color_l);
                    console.log(text_color_pre);
                    var color_code = text_color_pre.find((X) => color_l == X[0]);
                    console.log(color_code);
                    var class_active = color_code != null ? "active-done" : "";
                    color_code = color_code != null ? color_code[1] : "fff";

                    html_block_text +=
                        `<label class="color-select__item js_item cart_color_click ${class_active}" data-character="` +
                        colors_array[x] +
                        `" data-index="` +
                        x +
                        `"><input type="hidden" name="properties[` +
                        pname +
                        `]" value="` +
                        color_l +
                        `" data-hex="#` +
                        color_code +
                        `" form="` +
                        form_id +
                        `"><span>` +
                        colors_array[x] +
                        `</span></label>`;
                    text_color.push(color_code);
                    text_color_name.push(color_l);
                }
                console.log(html_block_text);
                console.log("-----------------");
                setTimeout(function () {
                    $(".cart-edit .preview_texts .preview_texts_inner").html("");
                    for (let x = 0; x < colors_array.length; x++) {
                        $(".cart-edit .preview_texts .preview_texts_inner").append("<span>" + colors_array[x] + "</span>");
                    }
                    $(".cart-edit .color-select__list").html(html_block_text);
                    if ($(".cart-edit .color-select__list").find(".color-select__item")[0] != undefined) {
                        $(".cart-edit .color-select__list").find(".color-select__item")[0].click();
                    }
                    $(".cart-edit .preview_texts .preview_texts_inner").each(function (ii, vv) {
                        $(vv)
                            .find("span")
                            .each(function (i1, v1) {
                                var color_name = text_color_name[i1].toUpperCase();
                                if (color_name.indexOf("MULTICOLOR") >= 0) {
                                    $(v1).css("color", "transparent");
                                    $(v1).css("--color_stroke", "#" + text_color[i1]);

                                    $(v1).css("-webkit-text-stroke", "1px " + "#" + text_color[i1]);
                                    $(v1).css("text-stroke", "1px " + "#" + text_color[i1]);
                                } else {
                                    $(v1).css("--color_stroke", "transparent");
                                    $(v1).css("color", "#" + text_color[i1]);

                                    $(v1).css("-webkit-text-stroke", "1px transparent");
                                    $(v1).css("text-stroke", "1px transparent");
                                }
                                // $(v1).css('color','#'+text_color[i1]);
                            });
                    });
                    $(".cart-edit")
                        .find(".change_color_name")
                        .html(
                            $(".cart-edit")
                                .find('[name="color-shades"][data-hex="#' + text_color[0] + '"]')
                                .attr("value")
                        );
                }, 1000);
            }
            if (!$(".cart-edit_main .product__media-list.carousel-main").hasClass("flickity-enabled")) {
                $.getScript("https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js", function () {
                    $cartcarousel = $(".cart-edit_main .product__media-list.carousel-main").flickity({
                        contain: true,
                        pageDots: true,
                        sync: ".cart-edit_main .thumbnail-list.carousel-nav",
                    });
                    $cartcarouselthumb = $(".cart-edit_main .thumbnail-list.carousel-nav").flickity({
                        asNavFor: ".cart-edit_main .product__media-list.carousel-main",
                        prevNextButtons: false,
                        draggable: false,
                        percentPosition: false,
                        pageDots: false,
                        groupCells: "100%",
                        contain: true,
                        cellAlign: "left",
                    });
                });
            }
            var colorsData = JSON.parse(document.getElementById("ColorShadesData").textContent) || [];
            if ($(".cart-edit").find("#pro_ColorShadesData").length > 0) {
                var colorsDatas = JSON.parse($(".cart-edit").find("#pro_ColorShadesData").html()) || [];
                colorsData = colorsDatas.items;
            }
            var html = "";
            for (var [index, color] of colorsData.entries()) {
                html += `
        <input type="radio" id="color-shade-${index}" name="color-shades" value="${color.name}" data-hex="${color.code}" class="visually-hidden color-select__input">
        <label for="color-shade-${index}" class="color-select__input-label">
          <img src="${color.src}" alt="${color.name}">
        </label>`;
            }
            $(".cart-edit color-select").addClass("is-same-color").html(html);

            if ($('.cart-edit input[name="Add Personalization?"]:checked').length > 0) {
                if ($('.cart-edit input[name="Add Personalization?"]:checked').val().toUpperCase() == "YES") {
                    $(".cart-edit .parent_div").show();
                } else {
                    $(".cart-edit .parent_div").hide();
                }
            }
        });
    });

    $("body").on("click", ".complementary-products-wrapper .add-to-cart-button, .complementary-product-carousel .add-to-cart-button, product-recommendations .quick-add__submit", function (e) {
        e.preventDefault();
        if ($('[name="color_selected"]').length > 0) {
            stored_color_type = $('[name="color_selected"]:checked').val();
        }

        $(".cart-edit").show();

        // Set title and button text for adding complementary products
        $(".cart-edit_popup-title").text("Complete the Look");
        $(".cart-edit_form-submit").text("Add To Cart");

        $(".cart-edit-popup-body").addClass("loading");
        if ($(".cart-edit_main .product__media-list.carousel-main").hasClass("flickity-enabled")) {
            $cartcarousel.flickity("destroy");
            $cartcarouselthumb.flickity("destroy");
            $(".cart-edit_main .thumbnail-list.carousel-nav").empty();
            $(".cart-edit_main .product__media-list.carousel-main").empty();
        }
        var full_colors = "";
        var colorsDatas = JSON.parse(document.getElementById("ColorShadesData").textContent) || [];
        $.each(colorsDatas, function (index, val) {
            full_colors += val.name + val.code + ",";
        });
        console.log(full_colors);
        var href = $(this).attr("data-url");
        $.get(href, function (data) {
            $(".cart-edit-popup-body").html(
                `<div class="cart-edit_popup product product--left product--thumbnail_slider product--mobile-show">${$(data).find(".productsection .product").html().replaceAll("template--", "template--cart--")}${
                    $(data).find(".select-cousion-popup_wrp").length > 0 ? $(data).find(".select-cousion-popup_wrp").html() : " "
                }</div>`
            );
            $(".cart-edit-popup-body").removeClass("loading"); 
                if (window.initPreselectedProduct && $(".cart-edit").find("#preselected-variants").length > 0) {
                    setTimeout(function () {
                        window.initPreselectedProduct();
                        var input = document.querySelector(".cart-edit").querySelector('#name-input');
                        input.value = input.value;
                        input.dispatchEvent(new Event('input', { bubbles: true }));
                        input.dispatchEvent(new Event('change', { bubbles: true }));

                    }, 200);
                }
        }).done(function (e) {
            if ($(".cart-edit").find("#pro_ColorShadesData").length > 0) {
                full_colors = "";
                var colorsDatas = JSON.parse($(".cart-edit").find("#pro_ColorShadesData").html()) || [];
                colorsDatas = colorsDatas.items;
                $.each(colorsDatas, function (index, val) {
                    full_colors += val.name + val.code + ",";
                });
                console.log(full_colors, " =======");
            }

            $(".cart-edit line-item-properties").find(".this-is-personalize-option").addClass("edit_cart");
            $(".cart-edit-popup-body").removeClass("loading");
            // console.log('~~~~',line_single_color);
            $(".cart-edit .product__description.rte.quick-add-hidden").hide();

            var form_id = $('.cart-edit form[data-type="add-to-cart-form"]').attr("id");
            if ($(".cart-edit").find(".thisis_color_radio").length > 0) {
                var label = document.querySelector("label[for=" + $(".cart-edit").find(".thisis_color_radio:checked").attr("id") + "]");
                console.log("mnbvhj nbvn bv", label);
                if (label) {
                    var bgColor = label.dataset.bg;
                    var bgImage = label.dataset.bg_image;

                    var targetDiv = document.querySelector(".preview_texts");
                    console.log(targetDiv, bgColor, bgImage);
                    if (targetDiv && (bgColor != "" || bgImage != "")) {
                        setTimeout(function () {
                            $(targetDiv).css("background-color", bgColor);
                            $(targetDiv).css("background-image", bgImage);
                        }, 200);
                    }
                }
            }
            var previewTextBoxs = $(".cart-edit").find(".perparent-prod").find(".preview_texts .preview_texts_inner");
            previewTextBoxs.each(function (index, val) {
                fitText($(val));
            });
            $('.cart-edit [name="color_selected"]#samecolor').attr("checked", true).trigger("click");

            $(".cart-edit .color-select__list").addClass("hidden");

            if (!$(".cart-edit_main .product__media-list.carousel-main").hasClass("flickity-enabled")) {
                $.getScript("https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js", function () {
                    $cartcarousel = $(".cart-edit_main .product__media-list.carousel-main").flickity({
                        contain: true,
                        pageDots: true,
                        sync: ".cart-edit_main .thumbnail-list.carousel-nav",
                    });
                    $cartcarouselthumb = $(".cart-edit_main .thumbnail-list.carousel-nav").flickity({
                        asNavFor: ".cart-edit_main .product__media-list.carousel-main",
                        prevNextButtons: false,
                        draggable: false,
                        percentPosition: false,
                        pageDots: false,
                        groupCells: "100%",
                        contain: true,
                        cellAlign: "left",
                    });
                });
            }
            var colorsData = JSON.parse(document.getElementById("ColorShadesData").textContent) || [];
            if ($(".cart-edit").find("#pro_ColorShadesData").length > 0) {
                var colorsDatas = JSON.parse($(".cart-edit").find("#pro_ColorShadesData").html()) || [];
                colorsData = colorsDatas.items;
            }
            var html = "";
            for (var [index, color] of colorsData.entries()) {
                html += `
        <input type="radio" id="color-shade-${index}" name="color-shades" value="${color.name}" data-hex="${color.code}" class="visually-hidden color-select__input">
        <label for="color-shade-${index}" class="color-select__input-label">
          <img src="${color.src}" alt="${color.name}">
        </label>`;
            }
            $(".cart-edit color-select").addClass("is-same-color").html(html);

            if ($('.cart-edit input[name="Add Personalization?"]:checked').length > 0) {
                if ($('.cart-edit input[name="Add Personalization?"]:checked').val().toUpperCase() == "YES") {
                    $(".cart-edit .parent_div").show();
                } else {
                    $(".cart-edit .parent_div").hide();
                }
            }
        });
    });

    $("body").on("click", ".cart-edit_popup-close, .cart-edit_form-cancel", function (e) {
        e.preventDefault();
        $(".cart-edit").hide();

        // Reset to default values when closing
        $(".cart-edit_popup-title").text("Complete the Look");
        $(".cart-edit_form-submit").text("Add To Cart");
    });

    $(".cart-edit_popup-close,.cart-edit_form-cancel").on("click", function (e) {
        e.preventDefault();
        $(".cart-edit_popup").html(" ");
        $(this).parents(".cart-items-block").find(".cart-edit").hide();
    });
    $("body").on('.cart-edit .this-is-personalize-option [name="Want to Personalized"]', "change", function (e) {
        e.preventDefault();
        console.log($(this).attr("value"), " ssss", $(this).parents("product-info").find(".customDescription.line-item-property__field").length);
        if ($(this).attr("value") == "No") {
            $(this).parents("product-info").find(".customDescription.line-item-property__field").hide();
        } else {
            $(this).parents("product-info").find(".customDescription.line-item-property__field").show();
        }
    });

    $("body").on("click", ".select-cousion-title", function () {
        $(".select-cousion-popup").addClass("active");
        $(".cousion-popup-overlay").addClass("popup-active");
        $("body").css("overflow-y", "hidden");
    });

    $("body").on("click", ".popup-close", function () {
        $(".select-cousion-popup").removeClass("active");
        $(".cousion-popup-overlay").removeClass("popup-active");
        $("body").css("overflow-y", "scroll");
    });

    $("body").on("click", ".preselector", function () {
        $(".select-cousion-popup").removeClass("active");
        $(".cousion-popup-overlay").removeClass("popup-active");
        $("body").css("overflow-y", "scroll");
        console.log($(this).find("img").attr("src"));
        $(".multi-image-section .select-image img").attr("src", $(this).find("img").attr("src"));
        $(".multi-image-section .select-image input").val($(this).find("img").attr("src"));
    });

        $("body").on("click", ".cart-edit_form-submit", function (e) {
        e.preventDefault();

         var $btn = $(this);

         $btn.addClass("loading").prop("disabled", true);

        var cart_line_remove = Number($(".cart-edit").attr("data-line_no"));
        console.log(cart_line_remove);
        $(".cart-common-parent .item-wrapper:eq(" + cart_line_remove + ") cart-remove-button").trigger("click");
        setTimeout(function () {
            $('.cart-edit form[data-type="add-to-cart-form"] button.product-form__submit').trigger("click");
            $(this).closest(".cart-edit_popup").html(" ");

            // Loader remove after add to cart process
        setTimeout(function () {
            $btn.removeClass("loading").prop("disabled", false);
        }, 2000);

            if ($(this).closest(".cart-edit").find('[name="color_selected"]').length > 0) {
                $(this)
                    .closest(".cart-edit")
                    .find('[name="color_selected"][value="' + stored_color_type + '"]')
                    .attr("checked", true)
                    .trigger("click");
            }
        }, 1000);
    });
    
    $("body").on("click", ".feature-collection .custom-arrow", function (e) {
        if ($(this).parents("section").find(".flickity-enabled").length > 0) {
            e.preventDefault();
            if ($(this).hasClass("custom-prev") || $(this).hasClass("custom-arrow-aprev")) {
                $(this).parents("section").find(".flickity-button.previous").trigger("click");
            } else {
                $(this).parents("section").find(".flickity-button.next").trigger("click");
            }
        }
    });
    $("body").on("click", ".new-arrival-section .new-arrival-wrapper .custom-arrow", function (e) {
        if ($(this).parents("section").find(".flickity-enabled").length > 0) {
            e.preventDefault();
            if ($(this).hasClass("slider-previous-button")) {
                $(this).parents("section").find(".flickity-button.previous").trigger("click");
            } else {
                $(this).parents("section").find(".flickity-button.next").trigger("click");
            }
        }
    });

    // After
    $(document).on("change", "variant-radios input, variant-selects select", function () {
        setTimeout(function () {
            // Handle pre-selected products
            if ($("body").find('[id="preselected-variants"]').length > 0) {
                const variantScript = document.getElementById("preselected-variants");
                if (variantScript) {
                    const variants = JSON.parse(variantScript.textContent);
                    const currentVariantId = getCurrentVariantId(); // You'll need this function
                    const variant = variants[currentVariantId];

                    if (variant) {
                        const preselectedDiv = document.querySelector("#preselected-preview-texts");
                        if (preselectedDiv) {
                            $(preselectedDiv).css({
                                "background-color": variant.background_color || "transparent",
                                color: variant.font_color || "#000000",
                                "font-family": variant.font_family || "inherit",
                            });
                        }
                    }
                }
            }

            // Handle regular variant colors
            if ($(".thisis_color_radio:checked").length > 0) {
                var label = document.querySelector("label[for=" + $(".thisis_color_radio:checked").attr("id") + "]");
                if (label && label.dataset.bg) {
                    var preselectedDiv = document.querySelector("#preselected-preview-texts");
                    var regularDiv = document.querySelector(".preview_texts");

                    if (preselectedDiv) {
                        $(preselectedDiv).css("background-color", label.dataset.bg);
                        if (label.dataset.bg_image) {
                            $(preselectedDiv).css("background-image", label.dataset.bg_image);
                        }
                    }
                    if (regularDiv) {
                        $(regularDiv).css("background-color", label.dataset.bg);
                        if (label.dataset.bg_image) {
                            $(regularDiv).css("background-image", label.dataset.bg_image);
                        }
                    }
                }
            }
        }, 300);
    });

    $('body').on("change",'[name="product_style"]',function(e){
        var styled_handle = $(this).attr("data-styled_handle");
        var name = $(this).val();
        var product_info = $(this).closest('product-info');
        var product = $(this).closest('.product');

        var url = new URL(window.location.href);
        url.pathname = '/products/' + styled_handle;

        fetch(url.toString())
        .then(res => res.text())
        .then(htmlText => {
            var parser = new DOMParser();
            var newDoc = parser.parseFromString(htmlText, 'text/html');

            // var newGallery = newDoc.querySelector('media-gallery');
            // var currentGallery = document.querySelector('media-gallery');

            // if (newGallery && currentGallery) {
            //     currentGallery.innerHTML = newGallery.innerHTML;

            //     console.log(product.find(".product__media-list.carousel-main").hasClass("flickity-enabled"));

            //     $.getScript("https://cdnjs.cloudflare.com/ajax/libs/flickity/2.2.2/flickity.pkgd.min.js", function () {
            //         $cartcarousel = product.find(".product__media-list.carousel-main").flickity({
            //             contain: true,
            //             pageDots: true,
            //             sync: ".product .thumbnail-list.carousel-nav",
            //             prevNextButtons: false,
            //         });
            //         $cartcarouselthumb = product.find(".thumbnail-list.carousel-nav").flickity({
            //             asNavFor: ".product .product__media-list.carousel-main",
            //             prevNextButtons: false,
            //             draggable: false,
            //             percentPosition: false,
            //             pageDots: false,
            //             groupCells: "100%",
            //             contain: true,
            //             cellAlign: "left",
            //         });
            //     });
            // }

            var newGalleries = newDoc.querySelectorAll('media-gallery');
            var currentGalleries = product[0].querySelectorAll('media-gallery');

            newGalleries.forEach((newGallery, index) => {
                var currentGallery = currentGalleries[index];
                if (currentGallery){

                    var $main = $(currentGallery).find('.carousel-main');
                    var $nav = $(currentGallery).find('.carousel-nav');

                    if ($main.hasClass('flickity-enabled')) {
                        $main.flickity('destroy');
                    }
                    if ($nav.hasClass('flickity-enabled')) {
                        $nav.flickity('destroy');
                    }

                    currentGallery.innerHTML = newGallery.innerHTML;

                    var $newMain = $(currentGallery).find(".product__media-list.carousel-main");
                    var $newNav = $(currentGallery).find(".thumbnail-list.carousel-nav");

                    $newMain.flickity({
                        contain: true,
                        pageDots: true,
                        prevNextButtons: false,
                        imagesLoaded: true,
                         initialIndex: 0 
                    });

                    $newNav.flickity({
                        asNavFor: $newMain[0],
                        prevNextButtons: false,
                        draggable: false,
                        percentPosition: false,
                        pageDots: false,
                        groupCells: "100%",
                        contain: true,
                        cellAlign: "left",
                        imagesLoaded: true,
                         initialIndex: 0 
                    });

                    setTimeout(function(){
                        $newMain.addClass("show_all");
                    },1500);

                }
            });
        
        })
        .catch(err => {
            console.error('Fetch error:', err);
        });

        if (product_info.length > 0) {
            product_info.find('.js_style_change').find('.form__label span').text(name);
            
            $('.style_change').hide();
            $(`.style_change[data-value_variant="${styled_handle}"]`).show();
            var parent = product_info.find('.most_loved_color_wrp');
            if(parent.length > 0) {
                var children = parent[0].querySelectorAll('.style_change');

                var hasVisibleChild = Array.from(children).some(child => {
                    return window.getComputedStyle(child).display !== 'none';
                });

                if (hasVisibleChild) {
                    parent[0].classList.add('has-visible-child');
                    parent[0].style.display = 'block';   
                } else {
                    parent[0].classList.remove('has-visible-child');
                    parent[0].style.display = 'none';
                }
            }   

            product_info.find('variant-radios').find('fieldset').each(function(index,fieldset) {
                var children = fieldset.querySelectorAll('.style_change');

                var visibleStyle = Array.from(children).filter(child => {
                    return window.getComputedStyle(child).display !== 'none';
                });

                if (visibleStyle.length > 0) {
                    console.log(fieldset);
                    var checkedRadio = fieldset.querySelector('input[type="radio"]:checked');

                console.log(" sssssssssssssssssssssss ", checkedRadio);

                    if (checkedRadio != null) {
                        var checkedLabel = fieldset.querySelector(`label[for="${checkedRadio.id}"]`);

                        console.log(checkedLabel, " ", checkedRadio.id, window.getComputedStyle(checkedLabel).display, " sss");

                        if (checkedLabel && window.getComputedStyle(checkedLabel).display !== 'none') {
                            return;
                        }
                    }

                    var firstVisibleLabel = visibleStyle[0];
                    var forAttr = firstVisibleLabel.getAttribute('for');

                    if (forAttr) {
                        var targetRadio = fieldset.querySelector(`#${forAttr}`);

                        if (targetRadio) {
                            targetRadio.checked = true;
                            targetRadio.dispatchEvent(new Event('change', { bubbles: true }));
                        }
                    }   
                }
            });

        }
    });

    if($('[name="product_style"]:checked').length > 0) {
        $('[name="product_style"]:checked').trigger('change');
    }

    // $(window).on("load", function(){
        setTimeout(function(){
            $('.product').find('media-gallery').each(function () {
                $(this)
                .find('.product__media-list').addClass("show_all");
            });
        },1500);
    // });    

    // Helper function to get current variant ID
    function getCurrentVariantId() {
        const radios = document.querySelector("variant-radios");
        if (radios) {
            const checked = radios.querySelector("input:checked");
            if (checked) {
                const variants = JSON.parse(radios.querySelector('script[type="application/json"]').textContent);
                const found = variants.find((v) => v.option1 === checked.value);
                return found ? found.id.toString() : Object.keys(JSON.parse(document.getElementById("preselected-variants").textContent))[0];
            }
        }
        return Object.keys(JSON.parse(document.getElementById("preselected-variants").textContent))[0];
    }

    // $('body').on('click', '.main-product-recommendations .custom-arrow', function(e) {
    //   if($(this).parents('product-recommendations').find('.flickity-enabled').length > 0){
    //     e.preventDefault();
    //     if($(this).hasClass('custom-prev')){
    //       $(this).parents('product-recommendations').find('.flickity-button.previous').trigger('click');
    //     }else{
    //       $(this).parents('product-recommendations').find('.flickity-button.next').trigger('click');
    //     }
    //   }
    // });

    // $('body').on('click', '.preselector', function() {
    //   var preselectorData = JSON.parse($(this).find('[type="application/json"]').html());
    //   console.log(preselectorData);
    //   // var previewTextBoxs = $('.preview_texts');
    //   // var notes = $('line-item-properties [name="properties[Notes]"]');
    //   var fontInputs = $('.font-select [type=radio]');
    //   // var colorTypes = $('color-personalization [name="color"]');
    //   var colorInputs = $('color-select .color-select__input');

    //   var variantSelectors = $('variant-selects') || $('variant-radios');
    //   console.log(preselectorData.options);
    //   if (variantSelectors) variantSelectors.setOptions(preselectorData.options);

    //   $('.preselector').removeClass('selected');
    //   $(this).addClass('selected');

    //   if($('line-item-properties [name="properties[Notes]"]').val() == ''){
    //     $('line-item-properties [name="properties[Notes]"]').val(preselectorData.name);
    //   }
    //   $('.preview_texts').each(function(ii,vv){
    //     var value = $('line-item-properties [name="properties[Notes]"]').val().replace(/(?!<br>)([^\s\n\r])/g, '<span>$1</span>');
    //     vv.html(value.replace(/\n/g, '<br>'));
    //   });

    //   $('.font-select [type=radio][value="'+ preselectorData.font +'"]').click();

    //   $('color-personalization [name="color"]').each(function(ii,colorType){
    //     if (preselectorData.colors.length > 1 && colorType.val() == 'Each Character Different Color') {
    //       colorType.trigger('click');
    //     } else if (colorType.val() == 'Each character Same Color') {
    //       colorType.trigger('click');
    //     }
    //   });
    //   $('color-select .color-select__input[value="'+ preselectorData.colors[0].value +'"]').trigger('click');

    //   document.querySelector('color-personalization').init(preselectorData.colors);
    // });

    // const preselectors = document.querySelectorAll('.preselector');
    // preselectors.forEach((preselector) => {
    //   preselector.addEventListener('click', () => {
    //     const preselectorData = JSON.parse(preselector.querySelector('[type="application/json"]').textContent);
    //     const previewTextBoxs = document.querySelectorAll('.preview_texts');
    //     const notes = document.querySelector('line-item-properties [name="properties[Notes]"]');
    //     const fontInputs = document.querySelectorAll('.font-select [type=radio]');
    //     const colorTypes = document.querySelectorAll('color-personalization [name="color"]');
    //     const colorInputs = document.querySelectorAll('color-select .color-select__input');

    //     const variantSelectors = document.querySelector('variant-selects') || document.querySelector('variant-radios');
    //     if (variantSelectors) variantSelectors.setOptions(preselectorData.options);

    //     preselectors.forEach((preselector2) => { preselector2.classList.remove('selected')});
    //     preselector.classList.add('selected');

    //     if (notes.value == '') notes.value = preselectorData.name;

    //     previewTextBoxs.forEach((previewText) => {
    //       const value = notes.value.replace(/(?!<br>)([^\s\n\r])/g, '<span>$1</span>')
    //       previewText.innerHTML = value.replace(/\n/g, '<br>');;
    //     });

    //     fontInputs.forEach((input) => {
    //       if (input.value == preselectorData.font) input.click();
    //     });

    //     colorTypes.forEach((colorType) => {
    //       if (preselectorData.colors.length > 1 && colorType.value == 'Each Character Different Color') {
    //         colorType.click();
    //       } else if (colorType.value == 'Each character Same Color') {
    //         colorType.click();
    //       }
    //     });

    //     colorInputs.forEach((colorInput) => {
    //       if (colorInput.value == preselectorData.colors[0].value) colorInput.click();
    //     });

    //     document.querySelector('color-personalization').init(preselectorData.colors);
    //   });
    // });
});

// $(document).ready(function () {
//     // Check the selected value on page load
//     if ($('input[name="Add Personalization?"]:checked').val() === 'YES') {
//         $('.parent_div').show(); // Show the textarea if "YES" is already selected
//     }

//     // Show or hide the textarea based on radio button selection
//     $('input[name="Add Personalization?"]').on('change', function () {
//         if ($(this).val() === 'YES') {
//             $('.parent_div').slideDown(); // Show the textarea
//         } else {
//             $('.parent_div').slideUp(); // Hide the textarea
//         }
//     });
// });

$(".flickity-enabled").on("dragStart.flickity", function (event, pointer) {
    document.ontouchmove = function (e) {
        e.preventDefault();
    };
});
$(".flickity-enabled").on("dragEnd.flickity", function (event, pointer) {
    document.ontouchmove = function (e) {
        return true;
    };
});


$(document).ready(function () {
  if (window.innerWidth > 768) return;

  var $sticky = $('.sticky_media').first();
  var $trigger = $('.topinfo').first();
  var $bottomInfo = $('.product__info-main.bottominfo').first();
  var $previewStop = $('.parent_div.preview_text_wrp').first();

  if (!$sticky.length || !$trigger.length) return;

  var isVisible = false;
  var ticking = false;

  function showSticky() {
    if (isVisible) return;
    isVisible = true;
    $sticky.addClass('is-active');
  }

  function hideSticky() {
    if (!isVisible) return;
    isVisible = false;
    $sticky.removeClass('is-active');
  }

  function updateSticky() {
    var triggerRect = $trigger[0].getBoundingClientRect();
    var startSticky = triggerRect.top <= 240;

    var endSticky = false;

    if ($previewStop.length && $previewStop.is(':visible')) {
      var previewRect = $previewStop[0].getBoundingClientRect();
      endSticky = previewRect.top <= 260;
    } 

    else if ($bottomInfo.length) {
      var bottomRect = $bottomInfo[0].getBoundingClientRect();
      endSticky = bottomRect.bottom <= 280;
    }

    if (startSticky && !endSticky) {
      showSticky();
    } else {
      hideSticky();
    }

    ticking = false;
  }

  function requestTick() {
    if (!ticking) {
      window.requestAnimationFrame(updateSticky);
      ticking = true;
    }
  }

  $(window).on('scroll resize load', requestTick);
  requestTick();
});